import agent from '../agent'
import { orgsAddCommentToCommentsList, orgsReplaceCommentToCommentsList } from './OrgsCommentsList'
import {
    ORGS_COMMENTS_CREATED,
    ORGS_COMMENTS_LOADED,
    ORGS_COMMENTS_UNLOADED
} from "../constants/actionTypes"

export const orgsCommentCreated = (payload) => ({
    type: ORGS_COMMENTS_CREATED,
    payload
})

export const orgsCreateComment = (dispatch, getState) => (Id, body, viewMyPostsAndComments, replyMyPostsAndComments) => {
    agent.OrgsComments.createComment(Id, body, viewMyPostsAndComments, replyMyPostsAndComments).then(res => {
        dispatch(orgsCommentCreated(res));
        orgsLoadComments(dispatch, getState)(Id)
    }, err => {
        dispatch(orgsCommentCreated(err));
    })
}

export const orgsCreateReplyComment = (dispatch, getState) => (Id, commentId, body, viewMyPostsAndComments, replyMyPostsAndComments) => {
    agent.OrgsComments.createReply(Id, commentId, body, viewMyPostsAndComments, replyMyPostsAndComments).then(res => {
        dispatch(orgsCommentCreated(res));
        orgsLoadReplyComments(dispatch, getState)(Id, commentId)
    }, err => {
        dispatch(orgsCommentCreated(err));
    })
}

export const orgsCommentsLoaded = (payload) => ({
    type: ORGS_COMMENTS_LOADED,
    payload
})

export const orgsCommentsUnloaded = () => ({
    type: ORGS_COMMENTS_UNLOADED
})

export const orgsLoadComments = (dispatch, getState) => (id) => {
    agent.OrgsComments.getOrgsCommentsList(id).then(res => {
        dispatch(orgsCommentsLoaded(res));

        orgsAddCommentToCommentsList(dispatch, getState)(res);
    }, err => {
        dispatch(orgsCommentsLoaded(err));
    })
}

export const orgsLoadReplyComments = (dispatch, getState) => (postId, commentId) => {
    agent.OrgsComments.forPost(postId).then(res => {
        dispatch(orgsCommentsLoaded(res));
        let store = getState();
        // if (store && store.comments && store.comments.comment) {
        if (store && store.OrgsComments && store.OrgsComments.comment) {
            let newComment = res.find(item => item.id === commentId)
            orgsReplaceCommentToCommentsList(dispatch, getState)(newComment);
        }
    }, err => {
        dispatch(orgsCommentsLoaded(err));
    })
}
export const orgsUnloadComments = (dispatch) => () => {
    dispatch(orgsCommentsUnloaded());
}

